<template>
  <section class="p-2">
    <v-form ref="complincrule" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">Add Compliance Rule</div>
          <div>
            <bread-crumb :bread-crumbs="['Compliance Rules New']" />
          </div>
        </v-card-title>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
        <v-row class="mt-3 ms-3 me-3">
          <v-col cols="12" md="3" lg="3" xs="12">
            <label class="labelFontsize my-0 required"> Rule Name </label>
            <v-text-field
              dense
              outlined
              placeholder="Rule Name"
              class="rounded"
              v-model="complianceRuleobj.rule_name"
              :rules="ruleNameValidations"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card class="mb-8 ma-4">
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="2"
            width="170px"
          >
            <p class="font-weight-bold">
              <v-icon class="me-1">mdi-account-arrow-right-outline</v-icon
              >Sender Info
            </p>
          </v-sheet>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Sender Nationality </label>
              <v-autocomplete
                dense
                outlined
                placeholder="Sender Nationality "
                class="rounded"
                :items="NationalityList"
                v-model="complianceRuleobj.sender_nationality"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Sender country </label>
              <v-autocomplete
                dense
                outlined
                placeholder="Sender country"
                class="rounded"
                :items="countryOptions"
                @change="
                  getStates(),
                    getSendCountryPartners(complianceRuleobj.sender_country)
                "
                v-model="complianceRuleobj.sender_country"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> States </label>
              <v-autocomplete
                dense
                outlined
                placeholder="States"
                class="rounded"
                :items="state_options"
                v-model="complianceRuleobj.state"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Channel Partner </label>
              <v-autocomplete
                dense
                outlined
                placeholder="Channel Partner"
                class="rounded"
                item-text="txt"
                item-value="val"
                v-model="complianceRuleobj.sender_partner"
                :items="sender_Partner"
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Customer Occupation </label>
              <v-autocomplete
                dense
                outlined
                placeholder="Customer Occupation"
                class="rounded"
                :items="occupation_list"
                v-model="complianceRuleobj.customer_occupation"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Customer Type </label>
              <v-autocomplete
                dense
                outlined
                placeholder="Customer Type"
                class="rounded"
                v-model="complianceRuleobj.customer_type"
                :items="customer_Type"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Compliance Group Code </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder="Compliance Group Code"
                v-model="complianceRuleobj.compliance_grp_code"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Compliance Check Order </label>
              <v-text-field
                dense
                outlined
                placeholder="Compliance Check Order"
                class="rounded"
                v-model="complianceRuleobj.compliance_check_order"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mb-4 mt-2 ma-4">
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="2"
            width="170px"
          >
            <p class="font-weight-bold">
              <v-icon class="me-1">mdi-account-arrow-left-outline</v-icon>Payout
              Info
            </p>
          </v-sheet>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Payout Country </label>
              <v-autocomplete
                dense
                outlined
                placeholder=" Payout Country"
                class="rounded"
                :items="countryOptions"
                v-model="complianceRuleobj.payout_country"
                @input="getPayoutpartners(complianceRuleobj.payout_country)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Payout Partner </label>
              <v-autocomplete
                dense
                outlined
                class="rounded"
                placeholder="Payout Partner"
                v-model="complianceRuleobj.payout_partner"
                item-text="txt"
                item-value="val"
                :items="payout_Partner"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Payment Mode </label>
              <v-autocomplete
                dense
                outlined
                placeholder="Payment Mode"
                class="rounded"
                :items="modeOptions"
                item-text="txt"
                item-value="val"
                v-model="complianceRuleobj.payment_mode"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <v-switch
                label="Enable Rule"
                color="primary labelFontsize"
                dense
                class="mt-6"
                v-model="complianceRuleobj.is_enable"
              >
              </v-switch>
            </v-col>
          </v-row>
        </v-card>
        <v-divider class="mx-auto my-8" width="80%"></v-divider>

        <v-card class="mb-8 ma-4">
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="2"
            width="170px"
          >
            <p class="font-weight-bold">
              <v-icon class="me-1">mdi-bank-transfer</v-icon>Transaction Info
            </p>
          </v-sheet>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0">
                Apply rule if Nos of TXN more
              </label>
              <v-text-field
                dense
                outlined
                placeholder="Apply rule if Nos of TXN more"
                class="rounded"
                v-model="complianceRuleobj.no_of_transactions"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Agg.duration </label>
              <v-text-field
                dense
                outlined
                placeholder="Agg.Nos of"
                class="rounded ps-0 pt-0"
                v-model="complianceRuleobj.txn_no_of_days"
              >
                <!-- <template v-slot:append class="pt-0 ma-0 mt-0">
                  <v-menu
                    v-model="menuOpen"
                    :close-on-content-click="true"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        v-bind="attrs"
                        v-on="on"
                        plain
                        class="pa-0 ma-0 mt-0 my-auto"
                      >
                        {{ complianceRuleobj.txn_duration_type }}
                        <v-icon>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(option, index) in frequency_List"
                        :key="index"
                        color="primary"
                        @click="
                          complianceRuleobj.txn_duration_type = option.text
                        "
                      >
                        <v-list-item-title>{{ option.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu></template
                > -->
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> or (Choose any one) </label>
              <v-autocomplete
                dense
                outlined
                class="rounded"
                placeholder="Frequency"
                :items="frequency_List"
                v-model="complianceRuleobj.txn_no_of_days"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Apply Rule if </label>
              <v-autocomplete
                dense
                outlined
                placeholder="Apply Rule if"
                class="rounded"
                :items="rule_IF"
                v-model="complianceRuleobj.if_rule_match"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Amount </label>
              <v-text-field
                dense
                outlined
                placeholder="Amount"
                class="rounded"
                v-model="complianceRuleobj.if_amount"
              >
                <!-- <template v-slot:append class="pt-0 ma-0 mt-0">
                  <v-menu
                    v-model="currencyOpen"
                    :close-on-content-click="true"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        v-bind="attrs"
                        v-on="on"
                        plain
                        class="pa-0 ma-0 mt-0 my-auto"
                      >
                        {{ complianceRuleobj.currency_code }}
                        <v-icon>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(option, index) in currency_List"
                        :key="index"
                        color="primary"
                        @click="complianceRuleobj.currency_code = option.text"
                      >
                        <v-list-item-title>{{ option.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu></template
                > -->
              </v-text-field>
            </v-col>
            <v-col cols="12" md="1" lg="1" xs="12">
              <label class="labelFontsize my-0"> Currency </label>
              <v-autocomplete
                dense
                outlined
                placeholder="currency"
                class="rounded"
                :items="currency_List"
                v-model="complianceRuleobj.currency_code"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Agg.Nos of </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                :placeholder="`Agg.Nos of`"
                v-model="complianceRuleobj.amt_no_of_days"
              >
                <!-- <template v-slot:append class="pt-0 ma-0 mt-0">
                  <v-menu
                    v-model="amountOpen"
                    :close-on-content-click="true"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        v-bind="attrs"
                        v-on="on"
                        plain
                        class="pa-0 ma-0 mt-0 my-auto"
                      >
                        {{ complianceRuleobj.amt_duration_type }}
                        <v-icon>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(option, index) in frequency_List"
                        :key="index"
                        color="primary"
                        @click="
                          complianceRuleobj.amt_duration_type = option.text
                        "
                      >
                        <v-list-item-title>{{ option.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu></template
                > -->
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2" lg="2" xs="12">
              <label class="labelFontsize my-0"> or (Choose any one) </label>
              <v-autocomplete
                dense
                outlined
                class="rounded"
                placeholder="Frequency"
                :items="frequency_List"
                v-model="complianceRuleobj.amt_no_of_days"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" xs="12">
              <label class="labelFontsize my-0"> Date Type </label>
              <v-autocomplete
                dense
                outlined
                placeholder="Data Type"
                class="rounded"
                :items="date_Type"
                v-model="complianceRuleobj.date_type"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card>
        <v-divider class="mx-auto my-8" width="80%"></v-divider>
        <v-row class="ms-1 me-1">
          <v-col cols="12" md="3" lg="3" xs="12">
            <label class="labelFontsize my-0"> If above condition match </label>
            <v-autocomplete
              dense
              outlined
              placeholder="If above condition match "
              class="rounded"
              :items="above_Condition"
              v-model="complianceRuleobj.if_condition_match"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="3" lg="3" xs="12">
            <label class="labelFontsize my-0">
              Customer Risk Profile Score
            </label>
            <v-text-field
              placeholder=" Customer Risk Profile Score"
              dense
              type="number"
              outlined
              class="rounded"
              min="0"
              v-model.number="complianceRuleobj.risk_score"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" lg="3" xs="12">
            <v-switch
              label="Ask additional questions to Customer?"
              color="primary"
              class="mt-6"
              v-model="complianceRuleobj.is_ask_question"
            >
            </v-switch>
          </v-col>

          <v-col cols="12" md="3" lg="3" xs="12">
            <v-switch
              label="Mark Customer as High Risk Customer"
              color="primary"
              class="mt-6"
              v-model="complianceRuleobj.is_high_risk_customer"
            >
            </v-switch>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1">
          <v-col cols="12" md="3" lg="3" xs="12">
            <label class="labelFontsize my-0 required">
              Message display when Validation
            </label>
            <v-textarea
              outlined
              v-model="complianceRuleobj.description"
              :rules="descriptionValidationRule"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-col cols="12" md="12">
          <v-row class="d-flex justify-end">
            <v-btn
              depressed
              color="primary"
              small
              class="ma-2 mb-10 text-capitalize"
              @click="onSubmitFor()"
            >
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon
              >{{ $route.query.id ? "Update" : "Submit" }}
            </v-btn>
            <v-btn
              depressed
              small
              class="ma-2 me-6 text-capitalize"
              color="primary"
              outlined
              @click="cancel()"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
            </v-btn>
          </v-row>
        </v-col>
        <OverlayPageVue :showOverlay="loaderOverlay" />
      </v-card>
    </v-form>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import alerts from "@/mixins/alerts";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Compliance Rules New",
  mixins: [alerts],
  data: () => {
    return {
      valid: true,
      options: ["Option 1", "Option 2", "Option 3"],
      menuOpen: false,
      currencyOpen: false,
      loaderOverlay: false,

      amountOpen: false,
      complianceRuleobj: {
        rule_name: "",
        sender_nationality: "All",
        sender_country: "All",
        state: "All",
        payout_country: "All",
        sender_partner: "All",
        payout_partner: "All",
        payment_mode: "All",
        customer_occupation: "All",
        customer_type: "IND",
        compliance_grp_code: null,
        compliance_check_order: null,
        no_of_transactions: null,
        txn_no_of_days: null,
        txn_duration_type: null,
        if_amount: null,
        currency_code: null,
        amt_no_of_days: null,
        amt_duration_type: null,
        date_type: "",
        if_rule_match: "",
        if_condition_match: "",
        is_ask_question: null,
        is_high_risk_customer: null,
        risk_score: null,
        description: "",
        is_enable: null,
      },
      NationalityList: [],
      countryOptions: [],
      state_options: [],
      payoutcountryOptions: [],
      modeOptions: [
        {
          txt: "All",
          val: "All",
        },
      ],
      occupation_list: [],
      frequency_List: [],
      rule_IF: [],
      date_Type: [],
      currency_List: [],
      above_Condition: [],
      sender_Partner: [
        {
          txt: "All",
          val: "All",
        },
      ],
      risk_Profile: [],
      customer_Type: [],
      payout_Partner: [
        {
          txt: "All",
          val: "All",
        },
      ],
      ruleNameValidations: [
        (v) => !!v || "Rule Name is required",
        // (v) =>
        //   /^[a-zA-Z\s]*$/.test(v) || "Rule Name should contain only alphabets",
      ],
      descriptionValidationRule: [
        (v) => !!v || "Message display when Validation is required",
      ],
    };
  },
  components: {
    OverlayPageVue,
    BreadCrumb,
  },
  created() {
    if (this.$route.query.id) {
      this.editpage();
    } else {
      this.mountedData();
    }
  },
  mounted() {},
  methods: {
    mountedData() {
      this.getnational();
      this.getcountryList();
      this.getparameterdropdowns("PTY");
      this.getparameterdropdowns("OCC");
      this.getparameterdropdowns("PPT");
      this.getparameterdropdowns("UTP");
      this.getparameterdropdowns("FRY");
      this.getparameterdropdowns("ARI");
      this.getparameterdropdowns("CRY");
      this.getparameterdropdowns("DTY");
      this.getparameterdropdowns("IAC");
      this.getparameterdropdowns("CRP");
    },
    async getPayoutpartners(country_code) {
      try {
        const response = await partnerService.getAllPayoutPartners(
          country_code,
        );
        if (response.data.status_code === 200) {
          console.log("response.data.data partner", response.data.data);
          this.payout_Partner = response.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });

          this.payout_Partner.unshift({ txt: "All", val: "All" });
          this.getPaymentModes(this.complianceRuleobj.payout_country);
        }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },

    async getPaymentModes(country_code) {
      try {
        const responseData = await setupService.getpaymentmodeBycntry(
          country_code,
        );
        if (responseData.data.status_code === 200) {
          this.modeOptions = responseData.data.data.map((i) => {
            return {
              txt: i.payment_type.payment_mode,
              val: i.payment_type.payment_mode_code,
            };
          });
          this.modeOptions.unshift({ txt: "All", val: "All" });
        }
        console.log("Partners", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    replaceEmptyNull(object) {
      // Create a deep copy of the object to avoid modifying the original
      const updatedObject = JSON.parse(JSON.stringify(object));

      // Recursive function to replace empty strings with null
      const replaceEmptyWithNull = (obj) => {
        Object.keys(obj).forEach((key) => {
          if (obj[key] === "" && typeof obj[key] === "string") {
            obj[key] = null;
          } else if (typeof obj[key] === "object" && obj[key] !== null) {
            replaceEmptyWithNull(obj[key]);
          }
        });
      };
      replaceEmptyWithNull(updatedObject);
      return updatedObject;
    },
    openMenu() {
      this.menuOpen = true;
    },
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    onSubmitFor() {
      if (this.$route.query.id) {
        console.log("details");
        this.update();
      } else {
        console.log("else");
        this.saveData();
        // console.log('update')
      }
    },
    async getSendCountryPartners(country_code) {
      try {
        const responseData = await partnerService.getCountryPartners(
          country_code,
        );
        if (responseData.data.status_code === 200) {
          this.sender_Partner = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
          this.sender_Partner.unshift({ txt: "All", val: "All" });
        }
        console.log("Partners", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getnational() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getdropdowns();
        if (response.data.status_code === 200) {
          this.NationalityList = [
            { text: "All", value: "All" },
            ...response.data.data.map((i) => {
              return { text: i.nationality, value: i.iso_alpha3 };
            }),
          ];
          console.log("Nationalty", this.NationalityList);
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.NationalityList = [];
        //   this.returnNewToken();
        //   this.getnational();
        //   this.stoploader();
        // }
        else {
          this.NationalityList == [];
          this.stoploader();
        }
      } catch (error) {
        this.NationalityList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getcountryList() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getdropdowns();
        if (response.data.status_code === 200) {
          this.countryOptions = [
            { text: "All", value: "All" },
            ...response.data.data.map((i) => {
              return { text: i.country_name, value: i.iso_alpha3 };
            }),
          ];
          console.log("countryOptions", this.countryOptions);
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.countryOptions = [];
        //   this.returnNewToken();
        //   this.getcountryList();
        //   this.stoploader();
        // }
        else {
          this.countryOptions == [];
          this.stoploader();
        }
      } catch (error) {
        this.countryOptions = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getStates() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getStates(
          this.complianceRuleobj.sender_country,
        );
        if (response.data.status_code === 200) {
          this.state_options = [
            { text: "All", value: "All" },
            ...response.data.data.map((i) => {
              return { text: i.name, value: i.state_code };
            }),
          ];
          console.log("state_options", this.state_options);
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.state_options = [];
        //   this.returnNewToken();
        //   this.getStates();
        //   this.stoploader();
        // }
        else {
          this.state_options == [];
          this.stoploader();
        }
      } catch (error) {
        this.state_options = [];
        this.stoploader();
        console.error(error);
      }
      this.getSendCountryPartners(this.complianceRuleobj.sender_country);
    },
    async getparameterdropdowns(code) {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          switch (code) {
            case "PTY":
              console.log("PTY codes", response.data.data);
              this.modeOptions = [
                { txt: "All", val: "All" },
                ...response.data.data.map((i) => {
                  return { txt: i.value, val: i.value_code };
                }),
              ];
              break;
            case "OCC":
              console.log("OCC codes", response.data.data);
              this.occupation_list = [
                { text: "All", value: "All" },
                ...response.data.data.map((i) => {
                  return { text: i.value, value: i.value_code };
                }),
              ];
              break;
            case "PPT":
              console.log("PPT codes", response.data.data);
              this.payout_Partner = [
                { txt: "All", val: "All" },
                ...response.data.data.map((i) => {
                  return { txt: i.value, val: i.value_code };
                }),
              ];
              break;
            case "UTP":
              console.log("UTP codes", response.data.data);
              this.customer_Type = [
                // { text: "All", value: "All" },
                ...response.data.data.map((i) => {
                  return { text: i.value, value: i.value_code };
                }),
              ];
              break;
            case "FRY":
              console.log("FRY codes", response.data.data);
              this.frequency_List = [
                ...response.data.data.map((i) => {
                  return { text: i.value, value: i.value_code };
                }),
              ];
              break;
            case "ARI":
              console.log("ARI codes", response.data.data);
              this.rule_IF = [
                ...response.data.data.map((i) => {
                  return { text: i.value, value: i.value_code };
                }),
              ];
              break;
            case "CRY":
              console.log("CRY codes", response.data.data);
              this.currency_List = [
                ...response.data.data.map((i) => {
                  return { text: i.value, value: i.value_code };
                }),
              ];
              break;
            case "DTY":
              console.log("DTY codes", response.data.data);
              this.date_Type = [
                ...response.data.data.map((i) => {
                  return { text: i.value, value: i.value_code };
                }),
              ];
              break;
            case "IAC":
              console.log("IAC codes", response.data.data);
              this.above_Condition = [
                ...response.data.data.map((i) => {
                  return { text: i.value, value: i.value_code };
                }),
              ];
              break;

            case "CRP":
              console.log("CRP codes", response.data.data);
              this.risk_Profile = [
                // { text: "All", value: "All" },
                ...response.data.data.map((i) => {
                  return { text: i.value, value: i.value_code };
                }),
              ];
              break;
          }
        }
      } catch (error) {
        this.transItems = [];

        console.error(error);
      }
    },
    async saveData() {
      const validate = this.$refs.complincrule.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await setupService.PostRule(
            this.replaceEmptyNull(this.complianceRuleobj),
          );
          if (responseData && responseData.data.status_code == 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
            this.cancel();
            setTimeout(() => this.$router.push("/getCompliancerule"), 300);
          }
          // else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.saveData();
          // }
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.stoploader();
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async editpage() {
      const routerDataItem = this.$route.query.id;
      this.loaderOverlay = true;
      if (routerDataItem) {
        try {
          const response = await setupService.getrulebyId(routerDataItem);
          // alert("response");
          if (response.data.status_code === 200) {
            this.complianceRuleobj = response.data.data[0];
            this.complianceRuleobj.amt_no_of_days = response.data.data[0]
              .amt_no_of_days
              ? response.data.data[0].amt_no_of_days.toString()
              : null;
            this.complianceRuleobj.txn_no_of_days = response.data.data[0]
              .txn_no_of_days
              ? response.data.data[0].txn_no_of_days.toString()
              : null;
            this.mountedData();
            this.getStates();
            this.stoploader();
          } else {
            this.stoploader();
          }
        } catch (error) {
          this.stoploader();
          console.error(error);
        }
      } else {
        this.loaderOverlay = false;
      }
    },
    async update() {
      this.loaderOverlay = true;
      try {
        const responseData = await setupService.updateRule(
          this.$route.query.id,
          this.replaceEmptyNull(this.complianceRuleobj),
        );
        if (responseData && responseData.data.status_code == 200) {
          this.stoploader();
          this.showAlertSuccess(responseData.data.message);
          setTimeout(() => this.$router.push("/getCompliancerule"), 300);
        }
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.update();
        // }
        else {
          this.showAlertError(responseData.data.message);
          this.stoploader();
        }
      } catch (error) {
        console.log(error.response);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    cancel() {
      this.$refs.complincrule.reset();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
